<template>
    <TheSkinSwiper :showSkinArticles="combinationSkin" skinType="混合肌" />
</template>

<script setup>
import { ref } from 'vue';
import TheSkinSwiper from '@/components/widget/TheSkinSwiper.vue';
import data from '@/assets/data/combinationSkin.json';

let combinationSkin = ref(data.articles);
</script>
